module.exports = __webpack_public_path__ + "img/or-menachem-banim.bf0f0d0a.jpg";